/** Default output volume in dBFS (-12 dB ≈ 0.251 linear gain) */
export const DEFAULT_VOLUME_DB = -12;
